module.exports = require('vue')